<template>
  <div class="MyBuilder__body__body__holder__cards d-flex flex-colum" >
    <div class="cardsFloorplanHolder h-100">
      <div class="MyBuilder__body__body__holder__cards__holder " v-if="this.$store.state.floorplans.length > 0">
        <div class="MyBuilder__body__body__holder__card"
             v-for="(floorplan,index) in this.$store.state.floorplans" :key="index"
             @click="commit_floorplan(floorplan)"
             :class="active(floorplan.title)"
        >
          <div class="imageHolder">
            <i class="icon-checkbox-light"></i>
          </div>
          <div class="w-100">
            <div class="floorplanTitle">{{ floorplan.title }}</div>
            <div class="floortplan_description"><span v-if="floorplan.bedrooms !== ''">{{ floorplan.bedrooms }} rum , </span><span v-if="floorplan.dimensions !== ''">{{ floorplan.dimensions }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="MyBuilder__body__body__holder__btn_holder">
      <div class="summaryHolder">
        <div class="subTitle">Sub total:</div>
        <div class="TotalPrice">{{formatNumber(countTotal()) }} kr</div>
      </div>
      <button class="btn checkout_btn_primary" @click="CommitNextStep"  :disabled="Object.keys(this.currentFloorplan).length <= 0">
        {{'Nästa'}}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "floorplan_cards",
  components: {},
  computed: {
    activeLeftNav() {
      return this.$store.state.activeLeftNav
    },
    currentFloorplan() {
      return this.$store.state.currentFloorplan
    },

  },
  methods: {
    formatNumber(num){
      console.log(num)
       num = parseFloat(num)
       num =  (num-(num%100))/100 //remove last two numbers
      // If it is a float, restrict to 2 decimals
      num = num % 1 !== 0 ? num.toFixed(4) : num.toFixed(0)
      num = num.replace('.', ',')

      return  !num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    CommitNextStep(){
      this.$store.commit('mutate_activeLeftNav','pakets')
     // this.$store.dispatch('create_order')
     // this.$store.commit('mutate_activeLeftNav','pakets')
     // this.$store.dispatch('create_order')
    },
    countTotal(){
      return this.$store.state.order.order_amount + this.$store.state.order.order_tax_amount
    },
    active(e) {
      return Object.keys(this.$store.state.currentFloorplan).length > 0 && this.$store.state.currentFloorplan.title === e ? 'active' : ''
    },
    commit_floorplan(e) {
      this.$store.dispatch('commit_floorplan', e)
    },

  }
}
</script>

<style lang="scss" scoped>
.MyBuilder__body__body__holder__cards{
  display: flex;
  flex-direction: column;
  .cardsFloorplanHolder{
    height: 100%;

    .MyBuilder__body__body__holder__card{
      &:not(:last-of-type){
        border-bottom: 1px solid #F8F8F8;
      }
      display: flex;
      gap: 16px;
      align-items: center;
      padding: 8px 35px 8px 15px;
      cursor: pointer;
      &:hover{
        background-color: rgb(151 151 151 / 10%);
      }
      &.active{
        .imageHolder{
          i.icon-checkbox-light{
            color: #4e9280;
            &:before{
              content: "\e947";
            }
          }
        }
      }

      .imageHolder{
        i.icon-checkbox-light{
          font-size: 18px;
          color: #8F8F8F;
          height: 22.5px;
          width: 22.5px;
        }
      }
      .floorplanTitle{
        font-weight: 500;
        font-size: 14px;
        line-height: 167%;
        color: #000000;
      }
      .floortplan_description{
        font-weight: 400;
        font-size: 11px;
        line-height: 13px;
        color: #8F8F8F;
      }
    }
  }
  .MyBuilder__body__body__holder__btn_holder{
    .summaryHolder{
      font-size: 12px;
      line-height: 14px;
      color: #000000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 7px 0;
      .TotalPrice{
        font-weight: 600;
      }
    }
    padding: 10px;
  }
}
</style>
